import React, { useState } from "react";
import RequestTableItem from "./TableItem";
import RequestTableItemMobile from "./TableItemMobile";
import { isMobile } from "../../../../../../helpers/Mobile";

import styles from "./Table.module.scss";
const PrepOrdersTable = ({
  requestOrders,
  headers,
  headerClickHandler,
  handleClickRequestOrder,
  handleClickDraft,
  mapTypes
}) => {
  const [selectAll, setSelectAll] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleSelectOne = (selectedNew) => {
    if (selected === selectedNew) {
      setSelected(null);
    }
    setSelectAll(false);
  };

  // let isMobile = true
  const table = (
    <div
      className={styles["prep-order-table"]}
      data-automation-id="prep-order-table"
    >
      <div className={styles["prep-order-table-header"]}>
          {Object.keys(headers).map((headerKey, index) => {
            let header = headers[headerKey]
            return (
              <div
                key={header.name}
                data-automation-id={`sort-by-${header.name}`}
                onClick={() => {
                  headerClickHandler(header.name);
                }}
                data-filter-name={header.name}
               className={`${styles['prep-order-table-header-item']} ${styles[`table-header-${header.name}`]}`}
              >
                {header.title}{" "}
                <span
                className={`${styles['prep-order-table-header-icon-span']} ${header.active ? styles.active : ''} ${!header.direction ? styles.down : ''}`}
                >
                  {" "}
                  <i className="icon-iconos_flecha-ordenar"></i>
                </span>
              </div>
            );
          })}
          <div className={styles["table-header-action"]}></div>
      </div>
      <div className={styles["prep-order-table-content"]}>
        {requestOrders.map((requestOrder) => {
          return (
            <div className={styles["prep-order-table-content-item"]} key={requestOrder.id}>
              <RequestTableItem
                requestOrder={requestOrder}
                isSelected={
                  selected === requestOrder.id || selectAll
                }
                handleSelect={handleSelectOne}
                handleClick={requestOrder.status === 'DRA' ? handleClickDraft : handleClickRequestOrder}
                mapTypes={mapTypes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );

  const tableMobile = (
    <div className={styles["prep-order-table-mobile"]} data-automation-id="product-prep-order-table">
      <div className={styles["prep-order-table-content"]}>
        {requestOrders.map((requestOrder) => {
          return (
            <div className={styles["prep-order-table-content-item"]} key={requestOrder.id}>
              <RequestTableItemMobile
                requestOrder={requestOrder}
                isSelected={
                  selected === requestOrder.id || selectAll
                }
                handleSelect={handleSelectOne}
                handleClick={requestOrder.status === 'DRA' ? handleClickDraft : handleClickRequestOrder}
                mapTypes={mapTypes}
              />
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div className={styles["prep-order-table-container"]}>{isMobile ? tableMobile : table}</div>
  );
};

export default PrepOrdersTable;
